module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/115.cdad9c24.png";